import React, { useState, useContext } from 'react'
import '../styles/componentsStyles/TabAdder.scss'
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { TabAdderDisplay } from '../context/TabAdderDisplay'
import { Auth } from '../context/Auth';

const TabAdder = () => {
    const [tabName, setTabName] = useState("");
    const [channelId, setChannelId] = useState("");
    const tabAdderDisplay = useContext(TabAdderDisplay);
    const auth = useContext(Auth);
    const notifySomethingWrong = () => toast("⚠️ Something Went Wrong, Try Again!");

    const closeTabAdderForm = () => {
        tabAdderDisplay.showTabAdderFormDispatch({ type: 'closeAddTabForm' })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(auth.authState, "auth.authState")

        await axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: auth.authState.userId })
            .then(res => {
                console.log(res, "fetch User in Hidden Component");
                if (res.data.statusText === "success") {
                    if (res.data.user.channelId) {
                        // auth.authReducerDispatch({ type: "updateChannelId", payload: { channelId: res.data.user.channelId } });
                        // setChannelId(channelId);
                        addTab(res.data.user.channelId);
                    }
                }
            })
            .catch(err => console.log(err))

        // Generate UniqueID for tabs (i.e, tabId) 
        async function addTab(channelID) {
            const uniqueTabID = uuidv4();
            await axios.post(`${BASE_URL}/api/tabs`, { id: uniqueTabID, channelId: channelID, title: tabName })
                .then(res => {
                    console.log(res, "tab adder res")
                    if (res.data.statusText === "success") {
                        tabAdderDisplay.showTabAdderFormDispatch({ type: 'closeAddTabForm' });
                        tabAdderDisplay.showTabAdderFormDispatch({ type: 'formSubmitSuccess' });
                    } else {
                        notifySomethingWrong();
                        tabAdderDisplay.showTabAdderFormDispatch({ type: 'closeAddTabForm' });
                    }
                    console.log(res);
                }
                )
                .catch(err => {
                    tabAdderDisplay.showTabAdderFormDispatch({ type: 'closeAddTabForm' });
                    console.log(err)
                })
        }
    }

    return (
        <div className='tab-adder'>
            <form className="tab-adder__container">
                <h4>Add Tab</h4>
                <input type="text" maxLength={50} placeholder='Enter name of new tab' value={tabName} onChange={(e) => {
                    setTabName(e.target.value)
                }} autoFocus required />
                <button className='tab-adder__submit-btn' onClick={handleSubmit}>Add Tab</button>

                <button className='tab-adder__close-btn' onClick={closeTabAdderForm}>
                    <span class="material-symbols-outlined">
                        close
                    </span>
                </button>
            </form>
        </div >
    )
}

export default TabAdder